<template lang="pug">
  b-navbar(toggleable="md" class="d-flex flex-row " sticky )
    b-navbar-brand
      router-link(to="/home")
        img.logo(src="../../assets/images/mktBiLogo.png" )
    b-navbar-toggle(target="nav_collapse")
    b-collapse#nav_collapse(is-nav v-model="mobileMenu")
      .links.d-flex.flex-sm-column.flex-md-row.justification.flex-column.align-items-baseline(@click="mobileMenu = false")
        router-link(v-for="(link, i) in navLinks" :key="i" :to="routerLink(link)").navigation-link {{ link.name }}
        b-button.action(
          :style="{ fontSize: fontSizesPassed[2] + 'px', padding: buttonPadding }",
          variant='primary',
          text='Primary',
          @click="$router.push(routerLink({ page: 'About', name: 'About Us', section: 'contact' }))"
        ) {{ button }}
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      button: 'Contact Us',
      navLinks: [
        {page: 'Home', name: 'Solutions', section: 'solutions'},
        {page: 'Home', name: 'Use Cases', section: 'use-cases'},
        {page: 'Home', name: 'Benefits', section: 'benefits'},
        {page: 'About', name: 'About Us', section: ''},
        {page: 'Careers', name: 'Careers', section: ''},
      ],
      mobileMenu: false,
    }
  },

  props: {
    fontSizesPassed: {
      type: Array,
      default: () => ([50, 24, 16])
    }
  },
  methods: {
    routerLink(link) {
      if (!link.section) {
        return {name: link.page}
      } else {
        return {name: link.page, query: {section: link.section}}
      }
    }
  },
  computed: {
    buttonPadding() {
      return this.fontSizesPassed[2] + 'px ' + this.fontSizesPassed[2] * 1.8 + 'px'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
nav {
  background: white;
  padding-left: 10vw;
}

.logo {
  cursor: pointer;
}

.padded {
  padding-bottom: 7vh;
  padding-left: 10vw;
}

.links {
  // margin-left: auto;
  font-size: fontSizesPassed [3];
  margin-left: 10vw;

  .navigation-link {
    font-weight: bold;
    color: #364149 !important;
    text-transform: uppercase;
    margin: 5px 0 5px 4vw;
    cursor: pointer;
    text-decoration: none;
  }
}

.justification {
  align-items: center;
}

.navigation-link {
  text-align: right;
  &:after{
    content: '';
    display: block;
    height: 2px;
    width: 0;
    background: currentColor;
    margin: 3px auto 0;
    transition: .3s;
    opacity: 0;
  }
}

.router-link-exact-active{
  &:after{
    width: 90%;
    opacity: 1;
  }
}

.action {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  margin-left: 6vw;
  background: #5473E8;
  border-radius: 100px;
  font-style: normal;
  font-weight: bold;
  line-height: 18px;
  display: flex;
  align-items: flex-end;
  text-align: center;
  text-transform: uppercase;
  border: none;

}

@media only screen and (max-width: 767px) {
  /* smartphone */

  .action {
    display: none;
  }

  .padded {
    padding-right: 5vw;
  }

  .navigation-link {
    text-align: center;
    margin: 2em;
    width: 80%;

    &:hover {
      background: #5473E8
    }

  }


  .navbar-toggler {
    border: none;
  }
  .justification {
    align-items: center;
    margin: 0;
  }
}

@media only screen and (max-width: 1150px) {
  /* after smartphone & before large screen */

  .action {
    font-size: 12px;
    padding: 0.5vw;
  }

  .padded {
    padding-right: 1.5vw;
  }

  .navigation-link {
    text-align: center;
    margin-top: 1em;
    font-size: 12px;
    margin: 0 0 0 1vw;

  }


  .justification {
    align-items: center;
    margin: 0;
  }
}

</style>
